// extracted by mini-css-extract-plugin
export default {"container":"Responsive_container__uUhbt","rateBox":"Responsive_rateBox__KDCYb"};